import {Component, signal} from '@angular/core';

@Component({
  standalone: true,
  template: `
    <div class="error-msg">{{ text() }}</div>`,
})
export class ErrorMessageComponent {
  text = signal('');
}
